/** Barrel exports for the service-detail page components. */
export { default as HeroBookingCard } from './HeroBookingCard'
export { default as FeaturedAddons } from './FeaturedAddons'
export { default as ThingsToKnow } from './ThingsToKnow'
export { default as BeautyProsYouCanTrust } from './BeautyProsYouCanTrust'
export { default as CrossSell } from './CrossSell'
export { default as ReviewsSection } from './ReviewsSection'
export { default as FaqSection } from './FaqSection'
export { default as AppDownload } from './AppDownload'
